module.exports = __webpack_public_path__ + "img/how-2.5b9d354f.png";